export const ResourceId = {
  DASHBOARD: "dashboard",
  LIBRARY: "library",
  LICENSE: "license",
  SEASON: "season",
  TABLE: "table",
  UNIT: "unit",
  WAREHOUSE: "warehouse",
  SUPPLIER: "supplier",
  PRODUCT: "product",
  SIZE_CHART: "size_chart",
  ALERT_PARAMETER: "alert_parameter",
  CUSTOMER: "customer",
  DEPARTMENT: "department",
  FABRIC_CATEGORY: "fabric_category",
  FABRIC_PATTERN: "fabric_pattern",
  SETTING: "setting",
  USER: "user",
  ORDER: "order",
  FPO: "fpo",
  REPORT: "report",
  AUDIT: "audit",
  TASK: "task",
  EXTERNAL_APP: "externalApp",
  API_KEY: "apiKey",
  FABRIC: "fabric",
  FABRIC_RELEASE: "fabric_release",
  INVOICE: "invoice",
  ROLL: "roll",
  ROLL_RETURN: "roll_return",
  CLOSE_CUT_ORDER: "close_cut_order",
  GRN: "grn",
  LEDGER: "ledger",
  MATERIAL_TRANSFER: "material_transfer",
  MATERIAL_OUT: "material_out",
  GROUPING: "group",
  CUTPLAN: "cutplan",
  LAY: "lay",
  LAY_SYNC: "lay_sync",
  MICRO: "micro",
  MACRO: "macro",
  FEEDBACK: "feedback",
  NUMBERING_BUNDLING: "bundling",
  CUT_ORDER: "cut_order",  
  ORDER_FLOW: "order_flow",
  CUT_PLAN_APPROVAL: "cutplan_approval",
  CUT_ORDER_SETTING: "cut_order_setting",
  LOG: "log"
};

export const Scope = {
  READ: "read",
  WRITE: "write",
  UPDATE: "update",
  DELETE: "delete"
};
